import { Separator } from "../../../../../utils/utils";
import { getPlainTextFromHtml, removeTrailingEmptyLinesTextEditor } from "../utils/utils";

const useNewItemChange = (setItem, userIs, activeAccordion) => {
  console.log("activeAccordion", activeAccordion)

  const isMatchingItem = (currItem, item) => {
    if (item.IsRepeated === "true" && item.IsGroupEncounter === "true") {
      return (
        currItem.ItemID === item.ItemID &&
        currItem.PatientIntakeComponentItemID ===
        item.PatientIntakeComponentItemID
      );
    }

    return currItem.ItemID === item.ItemID;
  };

  const handleSetContent = (e) => {
    let navText = getInitials(e.target.value);
    setItem(prev => {
      return { ...prev, content: e.target.value, NavigationKeyword: navText }; // Return new state
    });
  }
  
  const handleSetContentDescription = (e) => {
    setItem(prev => {
      return { ...prev, answer: e.target.value }; // Return new state
    });
  }
  const handleSetContentTextEditor = (value) => {
    const cleanedHtml = removeTrailingEmptyLinesTextEditor(value);
    const plainText = getPlainTextFromHtml(cleanedHtml);
    let navText = getInitials(plainText);

    setItem(prev => {
      return { ...prev, content: value, NavigationKeyword: navText }; // Return new state
    });
  }

  const getInitials = (text) =>
    text.trim().split(/\s+/).slice(0, 3)
      .map(word => word[0]?.toUpperCase()).join("");

  const handleSetNavigationKeyword = (e) => {
    setItem(prev => {
      return { ...prev, NavigationKeyword: e.target.value }; // Return new state
    });
  }

  const handleIsRepeatToggle = (e) => {
    const checked = e.target.checked ? "true" : "false";

    setItem(prev => {
      return { ...prev, IsRepeated: checked }; // Return new state
    });
  }
  const handleSetIsRequired = (e) => {
    setItem(prev => {
      return { ...prev, isRequired: e.target.checked === true ? "true" : "false" }; // Return new state
    });
  }

  // const handleAddOption = () => {
  //     handleOptionsTextChange
  //     setOpt(prev => ([...prev, OPT_MODAL]))
  // }

  const handleOptionsTextChange = (e, index, type) => {
    setItem(prev => {
      let optionsArr = prev.options ? prev.options.split(Separator) : [];

      if (type === "AddOption") {
        // Start with an empty label + default meta
        optionsArr.push(`[TR=false|hintText='']`);
      }
      else if (type === "RemoveOption") {
        if (optionsArr.length > 1) {
          optionsArr.splice(index, 1);
        }
      }
      else if (type === "UpdateOption") {
        const { name, value, checked } = e.target;
        let optionStr = optionsArr[index] || "";

        // Break down current string
        const hasSelected = optionStr.includes("(D)");
        // const baseLabel = optionStr.split("(D)")[0].split("[")[0];
        const baseLabel = optionStr.replace(/\(D\).*/, "").replace(/\[.*$/, "");
        const hasMeta = optionStr.includes("[");
        let meta = hasMeta ? optionStr.slice(optionStr.indexOf("[")) : "[TR=false|hintText='']";

        if (name === "option") {
          // Update the label part
          optionsArr[index] = `${value}${hasSelected ? "(D)" : ""}${meta}`;
        }
        else if (name === "textResponse") {
          // Toggle TR flag
          const hintText = meta.match(/hintText='(.*?)'/)?.[1] ?? "";
          const trFlag = checked ? "true" : "false";
          meta = `[TR=${trFlag}|hintText='${hintText}']`;
          optionsArr[index] = `${baseLabel}${hasSelected ? "(D)" : ""}${meta}`;
        }
        else if (name === "hintText") {
          // Update hintText
          const trFlag = meta.match(/TR=(true|false)/)?.[1] ?? "false";
          const hintText = value;
          console.log("trFlag trFlag index", trFlag, index, hintText)
          meta = `[TR=${trFlag}|hintText='${hintText}']`;
          optionsArr[index] = `${baseLabel}${hasSelected ? "(D)" : ""}${meta}`;
          console.log("trFlag trFlag index", optionsArr.join(Separator))
        }
      }

      return { ...prev, options: optionsArr.join(Separator) };
    });
  };

  const handleViewerHintTextChange = (e, item, index) => {
    if (userIs !== 'Viewer') return;
    const { value } = e.target; // typed input

    setItem(prev =>
      prev.map(section => {
        if (section.key !== activeAccordion) return section;

        const updatedItems = section.items.map(currItem => {
          if (!isMatchingItem(currItem, item)) return currItem;

          const optionsArr = currItem.selectedOptions?.split(Separator) || [];
          let optionStr = optionsArr[index] || "";

          // Split base label and meta
          const baseLabel = optionStr.split("[")[0];
          const metaMatch = optionStr.match(/\[(.*?)\]/);
          let meta = metaMatch ? metaMatch[1] : "TR=false|hintText=''";

          // Remove old value if present, add new typed value
          meta = meta.replace(/\|?value='.*?'/, "");
          meta = `${meta}|value='${value}'`;

          // Rebuild option string, leave (D), TR, hintText untouched
          optionsArr[index] = `${baseLabel}[${meta}]`;
          console.log("data optionsArr", optionsArr)
          return { ...currItem, selectedOptions: optionsArr.join(Separator) };
        });
        return { ...section, items: updatedItems };
      })
    );
  };
  const handleSetAnswer = (e, item) => {
    // setItem(it => {
    //     console.log("item", it, activeAccordion)
    //     let prev = [...it[activeAccordion]].map((currItem) => {handleOptionsTextChange
    //         if (currItem.ItemID === item.ItemID) {
    //             return { ...currItem, answer: e.target.value };
    //         } else return currItem
    //     })
    //     return { ...it, [activeAccordion]: prev }
    // });
    // if (item.IsRepeated === 'true') {
    //   setItem(prev =>
    //     prev.map(section =>
    //       section.key === activeAccordion
    //         ? {
    //           ...section,
    //           items: section.items.map(currItem =>
    //             currItem.ItemID === item.ItemID && currItem.PatientIntakeComponentItemID === item.PatientIntakeComponentItemID
    //               ? { ...currItem, answer: e.target.value }
    //               : currItem
    //           )
    //         }
    //         : section
    //     )
    //   );
    // } else {
    setItem(prev =>
      prev.map(section =>
        section.key === activeAccordion
          ? {
            ...section,
            items: section.items.map(currItem =>
              isMatchingItem(currItem, item)
                ? { ...currItem, answer: e.target.value }
                : currItem
            )
          }
          : section
      )
    );
    // }
  }

  const handleSetDate = (e, item) => {
    const formatValue = (value) => {
      const formattedString = value.replace(/\D/g, ''); // Remove all non-numeric characters
      let formattedValue = '';
      if (formattedString.length >= 1) { formattedValue += formattedString.slice(0, 2); }
      if (formattedString.length >= 3) { formattedValue += '/' + formattedString.slice(2, 4); }
      if (formattedString.length >= 5) { formattedValue += '/' + formattedString.slice(4, 8); }
      return formattedValue;
    };
    const formattedValue = formatValue(e.target.value) || '';
    handleSetAnswer({ target: { value: formattedValue } }, item); // Pass the formatted value here
  };

  const handleSetSelectedDateSign = (e, item) => {
    const formatValue = (value) => {
      const formattedString = value.replace(/\D/g, ''); // Remove all non-numeric characters
      let formattedValue = '';
      if (formattedString.length >= 1) { formattedValue += formattedString.slice(0, 2); }
      if (formattedString.length >= 3) { formattedValue += '/' + formattedString.slice(2, 4); }
      if (formattedString.length >= 5) { formattedValue += '/' + formattedString.slice(4, 8); }
      return formattedValue;
    };
    const formattedValue = formatValue(e.target.value) || '';
    setItem(prev =>
      prev.map(section =>
        section.key === activeAccordion
          ? {
            ...section,
            items: section.items.map(currItem =>
              isMatchingItem(currItem, item)
                ? { ...currItem, SignatureDate: formattedValue }
                : currItem
            )
          }
          : section
      )
    );
  };

  const handleOptionChange = (index, checked) => {
    setItem(prev => {
      const updatedOptions = [...prev.options];
      updatedOptions[index].checked = checked;
      return { ...prev, options: updatedOptions };
    });
  };

  const handleOptionTextChange = (e) => {
    // const text = e.target.value;
    // setOptionsText(text);
    setItem(prev => {
      return { ...prev, answer: e.target.value }; // Return new state
    });

    // Split by new lines and map each line to an option
    // const newOptions = text.split('\n').map(line => ({ text: line, checked: false }));
    // setItem(prevItem => ({ ...prevItem, options: newOptions }));
  };

  // const handleAddOption = (item) => {
  //     let options = item.options;
  //     if (options.length === 0 || options[options.length - 1]) {
  //         setItem(prev => {
  //             const updatedOptions = [...(prev.options || []), { text: `Option ${options.length}`, checked: false }];
  //             return { ...prev, options: updatedOptions }; // Return new state with the updated options
  //         });
  //     } else {
  //         alert('Fill Required Fields')
  //     }
  // };
  const handleSelectMultipleOptions = (item, index) => {
    if (userIs !== 'Viewer') return;

    setItem(prev =>
      prev.map(section => {
        if (section.key !== activeAccordion) return section;

        const updatedItems = section.items.map(currItem => {
          if (!isMatchingItem(currItem, item)) return currItem;

          const optionsArr = currItem.selectedOptions?.split(',') || [];

          // Parse options into structured objects
          const parsedOptions = optionsArr.map(optStr => {
            const hasSelected = optStr.includes("(D)");
            const baseLabel = optStr.split("(D)")[0].split("[")[0];
            const metaMatch = optStr.match(/\[(.*?)\]/);
            const meta = metaMatch ? metaMatch[1] : "TR=false|hintText=''";

            let TR = meta.match(/TR=(true|false)/)?.[1] ?? "false";
            let hintText = meta.match(/hintText='(.*?)'/)?.[1] ?? "";
            let value = meta.match(/value='(.*?)'/)?.[1] ?? "";

            return { baseLabel, hasSelected, TR, hintText, value };
          });

          // Toggle the selected state for the clicked option
          const updatedOptions = parsedOptions.map((opt, idx) => {
            if (idx === index) {
              return { ...opt, hasSelected: !opt.hasSelected };
            }
            return opt;
          });

          // Rebuild the option strings with meta preserved
          const rebuiltOptions = updatedOptions.map(opt => {
            let meta = `TR=${opt.TR}|hintText='${opt.hintText}'`;
            if (opt.value) meta += `|value='${opt.value}'`;
            return `${opt.baseLabel}${opt.hasSelected ? "(D)" : ""}[${meta}]`;
          });

          return { ...currItem, selectedOptions: rebuiltOptions.join(',') };
        });

        return { ...section, items: updatedItems };
      })
    );
  }

  const handleSelectMultipleOptionsCheckList = (item, index) => {
    if (userIs !== 'Viewer') return;

    setItem(prev =>
      prev.map(section => {
        if (section.key !== activeAccordion) return section;

        const updatedItems = section.items.map(currItem => {
          if (!isMatchingItem(currItem, item)) return currItem;

          const optionsArr = currItem.selectedOptions?.split(Separator) || [];

          // Parse options into structured objects
          const parsedOptions = optionsArr.map(optStr => {
            const hasSelected = optStr.includes("(D)");
            const baseLabel = optStr.split("(D)")[0].split("[")[0];
            const metaMatch = optStr.match(/\[(.*?)\]/);
            const meta = metaMatch ? metaMatch[1] : "TR=false|hintText=''";

            let TR = meta.match(/TR=(true|false)/)?.[1] ?? "false";
            let hintText = meta.match(/hintText='(.*?)'/)?.[1] ?? "";
            let value = meta.match(/value='(.*?)'/)?.[1] ?? "";

            return { baseLabel, hasSelected, TR, hintText, value };
          });

          // Toggle the selected state for the clicked option
          const updatedOptions = parsedOptions.map((opt, idx) => {
            if (idx === index) {
              return { ...opt, hasSelected: !opt.hasSelected };
            }
            return opt;
          });

          // Rebuild the option strings with meta preserved
          const rebuiltOptions = updatedOptions.map(opt => {
            let meta = `TR=${opt.TR}|hintText='${opt.hintText}'`;
            if (opt.value) meta += `|value='${opt.value}'`;
            return `${opt.baseLabel}${opt.hasSelected ? "(D)" : ""}[${meta}]`;
          });

          return { ...currItem, selectedOptions: rebuiltOptions.join(Separator) };
        });

        return { ...section, items: updatedItems };
      })
    );
  }

  const handleSelectOptions = (item, index) => {
    if (userIs === 'Viewer') {
      setItem(prev => {
        return prev.map(section => {
          if (section.key === activeAccordion) {
            const updatedItems = section.items.map(currItem => {
              if (isMatchingItem(currItem, item)) {

                const opts = item.selectedOptions?.split(Separator).length > 0
                  ? item.selectedOptions.split(Separator).map(checkBox => {
                    checkBox = checkBox.split('(D)') || [];
                    return ({
                      content: checkBox[0],
                      checked: checkBox.length > 1 ? true : false
                    })
                  }) : [];

                const updatedOptions = [...opts];
                updatedOptions[index] = {
                  ...updatedOptions[index],
                  checked: !updatedOptions[index].checked // Toggle the checked state
                };

                // Convert updatedOptions back to a string
                const selectedOptions = updatedOptions
                  .map(option => `${option.content}${option.checked ? '(D)' : ''}`) // Add "(D)" if checked
                  .join(Separator);
                return { ...currItem, selectedOptions };
              }
              return currItem;
            });
            return { ...section, items: updatedItems };
          }
          return section;
        });
      });
    }
  }

  const handleSelectSingleOption = (item, index) => {
    if (userIs === 'Viewer') {
      setItem(prev => {
        return prev.map(section => {
          if (section.key === activeAccordion) {
            const updatedItems = section.items.map(currItem => {
              if (isMatchingItem(currItem, item)) {
                // Parse selectedOptions into array
                const options = currItem.selectedOptions?.split(',').map(optStr => {
                  const hasSelected = optStr.includes("(D)");
                  // const baseLabel = optStr.split("(D)")[0].split("[")[0].trim();
                  const baseLabel = optStr.split("(D)")[0].split("[")[0];
                  const meta = optStr.includes("[") ? optStr.slice(optStr.indexOf("[")) : "[TR=false|hintText='']";
                  const textResponse = meta.match(/TR=(true|false)/)?.[1] ?? "false";
                  const hintText = meta.match(/hintText='(.*?)'/)?.[1] ?? "";
                  return { baseLabel, hasSelected, meta, textResponse, hintText };
                }) || [];

                // Update checked state: only one option selected
                const updatedOptions = options.map((opt, idx) => ({
                  ...opt,
                  hasSelected: idx === index ? true : false,
                }));

                // Rebuild selectedOptions string
                const selectedOptions = updatedOptions
                  .map(opt => `${opt.baseLabel}${opt.hasSelected ? '(D)' : ''}${opt.meta}`)
                  .join(',');

                return { ...currItem, selectedOptions };
              }
              return currItem;
            });

            return { ...section, items: updatedItems };
          }
          return section;
        });
      });
    }
  };

  const handleSelectSingleOptionNew = (item, index) => {
    if (userIs === 'Viewer') {
      setItem(prev => {
        return prev.map(section => {
          if (section.key === activeAccordion) {
            const updatedItems = section.items.map(currItem => {
              if (isMatchingItem(currItem, item)) {
                // Parse selectedOptions into array
                const options = currItem.selectedOptions?.split(Separator).map(optStr => {
                  const hasSelected = optStr.includes("(D)");
                  // const baseLabel = optStr.split("(D)")[0].split("[")[0].trim();
                  const baseLabel = optStr.split("(D)")[0].split("[")[0];
                  const meta = optStr.includes("[") ? optStr.slice(optStr.indexOf("[")) : "[TR=false|hintText='']";
                  const textResponse = meta.match(/TR=(true|false)/)?.[1] ?? "false";
                  const hintText = meta.match(/hintText='(.*?)'/)?.[1] ?? "";
                  return { baseLabel, hasSelected, meta, textResponse, hintText };
                }) || [];

                // Update checked state: only one option selected
                const updatedOptions = options.map((opt, idx) => ({
                  ...opt,
                  hasSelected: idx === index ? true : false,
                }));

                // Rebuild selectedOptions string
                const selectedOptions = updatedOptions
                  .map(opt => `${opt.baseLabel}${opt.hasSelected ? '(D)' : ''}${opt.meta}`)
                  .join(Separator);

                return { ...currItem, selectedOptions };
              }
              return currItem;
            });

            return { ...section, items: updatedItems };
          }
          return section;
        });
      });
    }
  };

  const handleSelectDropdown = (item, index, action) => {
    if (userIs !== 'Viewer') return;

    setItem(prev =>
      prev.map(section => {
        if (section.key !== activeAccordion) return section;

        const updatedItems = section.items.map(currItem => {
          if (!isMatchingItem(currItem, item)) return currItem;

          // Parse selectedOptions
          const options = currItem.selectedOptions?.split(',').map(optStr => {
            const hasSelected = optStr.includes("(D)");
            const baseLabel = optStr.split("(D)")[0].split("[")[0];
            const meta = optStr.includes("[") ? optStr.slice(optStr.indexOf("[")) : "[TR=false|hintText='']";
            return { baseLabel, hasSelected, meta };
          }) || [];

          // Clear all selections if action === 'unSelect'
          if (action === 'unSelect') {
            const clearedOptions = options.map(opt => ({ ...opt, hasSelected: false }));
            return {
              ...currItem,
              selectedOptions: clearedOptions
                .map(opt => `${opt.baseLabel}${opt.hasSelected ? '(D)' : ''}${opt.meta}`)
                .join(','),
            };
          }

          // Otherwise, single-selection logic: only the clicked option is selected
          const updatedOptions = options.map((opt, idx) => ({
            ...opt,
            hasSelected: idx === index,
          }));

          // Rebuild selectedOptions string
          const selectedOptions = updatedOptions
            .map(opt => `${opt.baseLabel}${opt.hasSelected ? '(D)' : ''}${opt.meta}`)
            .join(',');

          return { ...currItem, selectedOptions };
        });

        return { ...section, items: updatedItems };
      })
    );
  };
  const handleOptionsTextChangeMulti = (e, index, type) => {
    setItem(prev => {
      let optionsArr = prev.options ? prev.options.split(Separator) : [];

      if (type === "AddOption") {
        optionsArr.push(`[TR=false|hintText='']`);
      }
      else if (type === "RemoveOption") {
        if (optionsArr.length > 1) {
          optionsArr.splice(index, 1);
        }
      }
      else if (type === "UpdateOption") {
        const { name, value, checked } = e.target;
        let optionStr = optionsArr[index] || "";

        // Parse components
        const isSelected = optionStr.includes("(D)");
        const baseLabel = optionStr.split("(D)")[0].split("[")[0];
        const hasMeta = optionStr.includes("[");
        let meta = hasMeta ? optionStr.slice(optionStr.indexOf("[")) : "[TR=false|hintText='']";

        if (name === "option") {
          // Change the visible label
          optionsArr[index] = `${value}${isSelected ? "(D)" : ""}${meta}`;
        }
        else if (name === "selected") {
          // Toggle "(D)" marker (multi-select allowed)
          if (checked) {
            // Mark as selected
            if (!isSelected) {
              optionsArr[index] = `${baseLabel}(D)${meta}`;
            }
          } else {
            // Unmark selected
            optionsArr[index] = `${baseLabel}${meta}`;
          }
        }
        else if (name === "textResponse") {
          // Toggle text response flag
          const hintText = meta.match(/hintText='(.*?)'/)?.[1] ?? "";
          const trFlag = checked ? "true" : "false";
          meta = `[TR=${trFlag}|hintText='${hintText}']`;
          optionsArr[index] = `${baseLabel}${isSelected ? "(D)" : ""}${meta}`;
        }
        else if (name === "hintText") {
          // Update hint text
          const trFlag = meta.match(/TR=(true|false)/)?.[1] ?? "false";
          const hintText = value;
          meta = `[TR=${trFlag}|hintText='${hintText}']`;
          optionsArr[index] = `${baseLabel}${isSelected ? "(D)" : ""}${meta}`;
        }
      }

      return { ...prev, options: optionsArr.join(Separator) };
    });
  };

  // const handleSelectSingleOption = (item, index) => {
  //   if (userIs === 'Viewer') {
  //     setItem(prev => {
  //       return prev.map(section => {
  //         if (section.key === activeAccordion) {
  //           const updatedItems = section.items.map(currItem => {
  //             if (currItem.ItemID === item.ItemID) {
  //               // Parse the `selectedOptions` into an array of objects
  //               const options = currItem.selectedOptions?.split(',').map(option => {
  //                 const [content, status] = option.split('(D)');
  //                 return {
  //                   content: content.trim(),
  //                   checked: Boolean(status),
  //                 };
  //               }) || [];

  //               // Update the checked state for a single selection
  //               const updatedOptions = options.map((opt, idx) => ({
  //                 ...opt,
  //                 checked: idx === index ? !opt.checked : false, // Only one can be checked
  //               }));

  //               // Convert the updated options back to a string
  //               const selectedOptions = updatedOptions
  //                 .map(opt => `${opt.content}${opt.checked ? '(D)' : ''}`)
  //                 .join(',');

  //               return { ...currItem, selectedOptions };
  //             }
  //             return currItem;
  //           });

  //           return { ...section, items: updatedItems };
  //         }
  //         return section;
  //       });
  //     });
  //   }
  // };


  // const handleFileChange = (e, item) => {
  //     setItem(it => {
  //         let prev = [...it].map((currItem) => {
  //             if (currItem.ItemID === item.ItemID) {
  //                 return { ...currItem, file: e.target.files[0] };
  //             } else return currItem
  //         })
  //         return prev
  //     });
  // };

  const handleFileChange = (e, item) => {
    const file = e.target.files[0];
    if (userIs === 'Viewer' && file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onloadend = (event) => {
        const base64 = event.target.result.split("base64,")[1];

        setItem(prev =>
          prev.map(section =>
            section.key === activeAccordion
              ? {
                ...section,
                items: section.items.map(currItem =>
                  isMatchingItem(currItem, item)
                    ? { ...currItem, answer: file.name, file: base64 }
                    : currItem
                ),
              }
              : section
          )
        );
      };
    }
  };
  const isSignPatientDefaultSignature = (obj) => {
    return obj?.type === 'PatientDefaultSignature' ? {
      "IsDefaultSignature": obj?.isDefaultSignature.toString()
    } : {}
  }
  const setItemWithFile = (item, fileName, base64, obj) => {
    setItem(prev =>
      prev.map(section =>
        section.key === activeAccordion
          ? {
            ...section,
            items: section.items.map(currItem =>
              isMatchingItem(currItem, item)
                ? { ...currItem, answer: fileName, file: base64, ...(isSignPatientDefaultSignature(obj)) }
                : currItem
            ),
          }
          : section
      )
    );
  };

  const handleRemoveFile = (item) => {
    if (userIs === 'Viewer') {
      setItem(prev =>
        prev.map(section =>
          section.key === activeAccordion
            ? {
              ...section,
              items: section.items.map(currItem =>
                isMatchingItem(currItem, item)
                  ? { ...currItem, answer: null, file: null }
                  : currItem
              )
            }
            : section
        )
      );
    }
  };

  const handleSetRatingScale = (options) => {
    if (userIs === 'Editor') {
      console.log("options", options)
      setItem(prev => {
        return { ...prev, options: options }
      });
    }
  };

  // const handleSetRatingScale = (options,item) => {
  //     if(userIs === 'Editor') {
  //         setItem(it => {
  //             console.log("activeAccordion",activeAccordion,it[activeAccordion])
  //             let prev = [...it[activeAccordion]].map((currItem) => {
  //                 if(currItem.ItemID === item.ItemID){
  //                     return { ...currItem, selectedOptions: options };
  //                 } else return currItem
  //             })
  //             return {...it , [activeAccordion]:prev}
  //         });
  //     }
  // };


  // Function for Table Change
  const handleChangeHeader = (item, e, index) => {
    if (userIs === 'Viewer') {
      // setItem((prevItem) => {
      //     ///////////////////////
      //     let currAccord = [...prevItem[activeAccordion]].map((currItem) => {
      //         if (currItem.ItemID === item.ItemID) {
      //             const newHeaders = [...currItem.headers];
      //             newHeaders[index] = e.target.value;
      //             return { ...currItem, headers: newHeaders }; // Return new state
      //         } else return currItem
      //     })
      //     return { ...prevItem, [activeAccordion]: currAccord }
      // })
      setItem((prevItem) => {
        const updatedAccord = prevItem.map(section => {
          if (section.key === activeAccordion) {
            let newItems = [...section.items].map((currItem) => {
              if (isMatchingItem(currItem, item)) {
                const newHeaders = [...currItem.headers];
                newHeaders[index] = e.target.value;
                return { ...currItem, headers: newHeaders }; // Return new state
              } else return currItem
            })
            return { ...section, items: newItems };
          } else return section
        });
        return updatedAccord;
      });
    }
  }
  const handleChangeRows = (item, e, rowIndex, cellIndex) => {
    if (userIs === 'Viewer') {
      let value = e.target.value;
      // value = value.replace(/,/g, ''); // remove commas

      // setItem((prevItem) => {
      //     ///////////////////////
      //     let currAccord = [...prevItem[activeAccordion]].map((currItem) => {
      //         if (currItem.ItemID === item.ItemID) {
      //             const newRows = [...currItem.rows];
      //             newRows[rowIndex] = [...newRows[rowIndex]];
      //             newRows[rowIndex][cellIndex] = e.target.value;
      //             return { ...currItem, rows: newRows }; // Return new state
      //         } else return currItem
      //     })
      //     return { ...prevItem, [activeAccordion]: currAccord }
      // })
      setItem((prevItem) => {
        const updatedAccord = prevItem.map(section => {
          if (section.key === activeAccordion) {
            let newItems = [...section.items].map((currItem) => {
              if (isMatchingItem(currItem, item)) {
                // console.log("CurrRows", item, value, rowIndex, cellIndex, currItem.rows);
                const newRows = currItem?.rows ? currItem.rows.split('\n') : [];
                console.log("CurrRowsnewRows", newRows, rowIndex);
                let updatedRows = currItem.rows; // Default to the original string
                // ✅ MINIMAL ADDITION (fix missing row issue)
                if (!newRows[rowIndex]) newRows[rowIndex] = '';
                if (newRows[rowIndex] !== undefined) {
                  // if (rowIndex < newRows.length) {
                  const rowArray = newRows[rowIndex].split(Separator);
                  rowArray[cellIndex] = value; // Update the specific cell
                  newRows[rowIndex] = rowArray.join(Separator); // Rebuild the updated row
                  updatedRows = newRows.join('\n'); // Rebuild the full string
                }
                // console.log("Updated Rows", updatedRows);
                return { ...currItem, rows: updatedRows }; // Ensure rows is a string
              } else return currItem
            })
            return { ...section, items: newItems };
          } else return section
        });
        return updatedAccord;
      });
    }
  }
  const handleAddRow = (item) => {
    if (userIs === 'Viewer') {
      setItem((prevItem) => {
        return prevItem.map((section) => {
          if (section.key !== activeAccordion) return section;

          const newItems = section.items.map((currItem) => {
            if (!isMatchingItem(currItem, item)) return currItem;

            const columnCount = Number(currItem.noOfHeaders) || 1;
            const rowsArray = currItem.rows
              ? currItem.rows.split("\n")
              : Array(Number(currItem.noOfRows) || 0).fill(Array(columnCount).fill("").join(Separator));

            rowsArray.push(Array(columnCount).fill("").join(Separator));
            return {
              ...currItem,
              rows: rowsArray.join("\n"),
              noOfRows: String(rowsArray.length),
            };
          });
          return { ...section, items: newItems };
        });
      });
    }
  };
  const handleDeleteRow = (item, rowIndex) => {
    setItem((prevItem) => {
      return prevItem.map((section) => {
        if (section.key !== activeAccordion) return section;

        const newItems = section.items.map((currItem) => {
          if (!isMatchingItem(currItem, item)) return currItem;

          const rowsArray = currItem.rows ? currItem.rows.split("\n") : [];
          rowsArray.splice(rowIndex, 1);

          return {
            ...currItem,
            rows: rowsArray.join("\n"),
            noOfRows: String(Math.max(rowsArray.length, 1)),
          };
        });

        return { ...section, items: newItems };
      });
    });
  };
  /////////////////////////////
  return {
    handleSetContent, handleSetContentDescription, handleSetContentTextEditor, handleSetNavigationKeyword, handleIsRepeatToggle, handleSetIsRequired, handleOptionsTextChange, handleViewerHintTextChange, handleOptionsTextChangeMulti, handleFileChange, handleRemoveFile, setItemWithFile, handleSelectMultipleOptions, handleSelectMultipleOptionsCheckList, handleSelectOptions, handleSelectSingleOption, handleSelectSingleOptionNew, handleSelectDropdown, handleSetAnswer, handleOptionChange, handleOptionTextChange,
    // handleAddOption,
    handleSetRatingScale, handleChangeHeader, handleChangeRows, handleSetDate, handleSetSelectedDateSign,
    handleAddRow, handleDeleteRow
  }
}

export default useNewItemChange